import { render, staticRenderFns } from "./DIASRealEstateBuyers.vue?vue&type=template&id=54a1fc79&"
import script from "./DIASRealEstateBuyers.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateBuyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports